export default __webpack_public_path__ + "static/media/radioShack.be7755c4.png";